export default {
    data() {
        return{
            activeName: 0
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/diversifiedTransport/diversifiedTransport.vue.js